// Код взят из @react-aria/utils

// HTML input types that do not cause the software keyboard to appear.
const nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset',
]);

/**
 * Проверяет, откроется ли клавиатура на мобильном устройстве при фокусе на target
 *
 * @param target - текущий активный элемент на странице
 * @returns true, если клавиатура откроется, иначе false
 */
export function willOpenMobileKeyboard(target: Element) {
    return (
        (target instanceof HTMLInputElement && !nonTextInputTypes.has(target.type)) ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable)
    );
}
